import type { CareNavigationDefinitionResponse } from "./careNavigationCriteria";
import { CarespaceCountLink } from "./carespaceCountLink";
import { KpiCard, KpiGrid } from "./dashboardKit";
import type { summarizeCompletionRows } from "./careNavigationDefinitionState";

export function completionPercentage(numerator: number | null, denominator: number) {
  return numerator === null || !denominator
    ? "—"
    : `${((numerator / denominator) * 100).toFixed(1)}%`;
}

export function CareNavigationCompletionKpis(props: {
  counts: ReturnType<typeof summarizeCompletionRows>["current"];
  loading?: boolean;
  unavailable?: boolean;
  emailFinalized?: boolean;
  sourceRows?: CareNavigationDefinitionResponse["rows"];
}) {
  const { counts } = props;
  const recordIds = (key: string) => [
    ...new Set(props.sourceRows?.flatMap((row) => row.recordIds?.[key] ?? [])),
  ];
  const value = (count: number | null) =>
    props.loading ? "…" : props.unavailable ? "—" : completionPercentage(count, counts.aligned);
  const emailState = props.loading
    ? "Loading email data"
    : counts.emailCompleted === null || props.unavailable
      ? "Email data unavailable"
      : !counts.aligned
        ? "No aligned, assigned CareSpaces"
        : props.emailFinalized
          ? "Finalized"
          : "Preliminary · awaiting month-end reconciliation";

  return (
    <KpiGrid className="md:grid-cols-2">
      <KpiCard
        label="Call completion"
        value={value(counts.completed)}
        footnote={
          props.loading ? (
            "Loading completion data"
          ) : props.unavailable ? (
            "Completion data unavailable"
          ) : (
            <>
              <CarespaceCountLink
                count={counts.completed}
                recordIds={recordIds("completed")}
                label="Call completions"
              />{" "}
              /{" "}
              <CarespaceCountLink
                count={counts.aligned}
                recordIds={recordIds("aligned")}
                label="Aligned CareSpaces"
              />{" "}
              aligned, assigned CareSpaces · active call criteria
            </>
          )
        }
      />
      <KpiCard
        label="Email completion"
        value={value(counts.emailCompleted)}
        footnote={
          <>
            {emailState}
            {!props.loading && !props.unavailable && counts.emailCompleted !== null ? (
              <>
                {" "}
                ·{" "}
                <CarespaceCountLink
                  count={counts.emailCompleted}
                  recordIds={recordIds("emailCompleted")}
                  label="Email completions"
                  preliminary={!props.emailFinalized}
                />{" "}
                / {counts.aligned} aligned CareSpaces
              </>
            ) : null}
          </>
        }
      />
    </KpiGrid>
  );
}
